import React, { useState } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import { Download, CreditCard, Building2, CheckCircle2 } from 'lucide-react';

const formatCurrency = (amount) => {
	const numAmount = Number(amount) || 0;
	return new Intl.NumberFormat('sv-SE', {
		style: 'currency',
		currency: 'SEK',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(numAmount);
};

const BankgirotFileDownloadModal = ({ show, handleClose, handleSelect, employeeSalaries }) => {
	const [selectedEmployeeSalaries, setSelectedEmployeeSalaries] = useState([]);

	const handleSelectChange = (event) => {
		const id = event.target.value;
		const selectedEmployeeSalary = employeeSalaries.find(salary => salary.id === id);
		console.log(selectedEmployeeSalary);
		setSelectedEmployeeSalaries(prevState =>
			prevState.includes(selectedEmployeeSalary) ?
				prevState.filter(salary => salary.id !== id) :
				[...prevState, selectedEmployeeSalary]
		);
	};

	const [formData, setFormData] = useState({
		customerNumber: '',
		bankgirotNumber: '',
	});

	const handleInputChange = (event) => {
		const { name, value } = event.target;
		console.log(name, value);
		setFormData({ ...formData, [name]: value });
	};

	const selectAll = () => {
		setSelectedEmployeeSalaries([...employeeSalaries]);
	};

	const selectNone = () => {
		setSelectedEmployeeSalaries([]);
	};

	const totalAmount = selectedEmployeeSalaries.reduce((sum, emp) => sum + parseFloat(emp.netpay || 0), 0);

	return (
		<>
			<style>{`
        .modern-modal .modal-content {
          border: none;
          border-radius: 12px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
        }
        
        .modern-modal .modal-header {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border-bottom: 1px solid #e5e7eb;
          border-radius: 12px 12px 0 0;
          padding: 2rem 2rem 1.5rem 2rem;
        }
        
        .modern-modal .modal-title {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 1.25rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
        }
        
        .modern-modal .modal-body {
          padding: 2rem;
        }
        
        .modern-modal .modal-footer {
          background: #f8fafc;
          border-top: 1px solid #e5e7eb;
          border-radius: 0 0 12px 12px;
          padding: 1.5rem 2rem;
          display: flex;
          gap: 1rem;
          justify-content: space-between;
          align-items: center;
        }
        
        .form-section {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 1.5rem;
          margin-bottom: 2rem;
        }
        
        .form-section-title {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 1rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 1rem;
        }
        
        .modern-form-group {
          margin-bottom: 1.5rem;
        }
        
        .modern-form-label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          margin-bottom: 0.5rem;
          display: block;
        }
        
        .modern-form-control {
          border: 1px solid #d1d5db;
          border-radius: 6px;
          padding: 0.75rem 1rem;
          font-size: 0.875rem;
          transition: all 0.2s ease;
          width: 100%;
        }
        
        .modern-form-control:focus {
          outline: none;
          border-color: var(--bs-primary);
          box-shadow: 0 0 0 3px rgba(68, 129, 78, 0.1);
        }
        
        .selection-controls {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
          align-items: center;
        }
        
        .btn-selection {
          background: #f1f5f9;
          border: 1px solid #e2e8f0;
          color: #64748b;
          padding: 0.5rem 1rem;
          border-radius: 6px;
          font-size: 0.75rem;
          font-weight: 500;
          transition: all 0.2s ease;
          cursor: pointer;
        }
        
        .btn-selection:hover {
          background: #e2e8f0;
          color: #475569;
        }
        
        .selection-summary {
          color: #64748b;
          font-size: 0.875rem;
          margin-left: auto;
        }
        
        .modern-table {
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          overflow: hidden;
          background: white;
        }
        
        .modern-table thead {
          background: #f8fafc;
        }
        
        .modern-table th {
          padding: 1rem;
          font-size: 0.75rem;
          font-weight: 600;
          color: #374151;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 1px solid #e5e7eb;
        }
        
        .modern-table td {
          padding: 1rem;
          font-size: 0.875rem;
          border-bottom: 1px solid #f3f4f6;
          vertical-align: middle;
        }
        
        .modern-table tbody tr:hover {
          background: #f8fafc;
        }
        
        .modern-table tbody tr.selected {
          background: #f0fdf4;
          border-left: 3px solid var(--bs-primary);
        }

        .modern-checkbox {
          width: 18px;
          height: 18px;
          accent-color: var(--bs-primary);
          cursor: pointer;
        }
        
        .employee-name {
          font-weight: 500;
          color: #1e293b;
        }
        
        .amount-cell {
          font-weight: 600;
          color: #059669;
        }
        
        .summary-card {
          background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
          border: 1px solid #86efac;
          border-radius: 8px;
          padding: 1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .summary-text {
          color: #166534;
          font-weight: 500;
        }

        .summary-amount {
          font-size: 1.125rem;
          font-weight: 700;
          color: #14532d;
        }
        
        .modern-btn {
          border-radius: 6px;
          padding: 0.75rem 1.5rem;
          font-weight: 500;
          font-size: 0.875rem;
          border: none;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          cursor: pointer;
        }
        
        .btn-modern-secondary {
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
        }
        
        .btn-modern-secondary:hover {
          background: #e2e8f0;
          color: #475569;
        }
        
        .btn-modern-primary {
          background: var(--bs-primary);
          color: white;
        }

        .btn-modern-primary:hover:not(:disabled) {
          background: var(--primary-hover);
          transform: translateY(-1px);
        }
        
        .btn-modern-primary:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }
        
        .info-text {
          font-size: 0.875rem;
          color: #64748b;
          line-height: 1.5;
          margin-bottom: 1.5rem;
        }
        
        @media (max-width: 768px) {
          .modern-modal .modal-header,
          .modern-modal .modal-body,
          .modern-modal .modal-footer {
            padding: 1.5rem 1rem;
          }
          
          .selection-controls {
            flex-direction: column;
            align-items: stretch;
          }
          
          .selection-summary {
            margin-left: 0;
            text-align: center;
          }
        }
      `}</style>

			<Modal show={show} onHide={handleClose} size='lg' className="modern-modal">
				<Modal.Header closeButton>
					<Modal.Title>
						<Download size={24} color="var(--bs-primary)" />
						Skapa Bankgirofil för Löner
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p className="info-text">
						Fyll i dina bankgirouppgifter och välj vilka löner som ska inkluderas i utbetalningsfilen.
						Filen kan sedan användas för automatisk överföring via din bank.
					</p>

					{/* Bank Information Section */}
					<div className="form-section">
						<div className="form-section-title">
							<Building2 size={18} color="var(--bs-primary)" />
							Bankgiroinformation
						</div>

						<div className="row">
							<div className="col-md-6">
								<div className="modern-form-group">
									<label className="modern-form-label">Kundnummer</label>
									<input
										type="text"
										className="modern-form-control"
										placeholder="Ange ditt kundnummer hos bankgirot"
										onChange={handleInputChange}
										name='customerNumber'
										value={formData.customerNumber}
									/>
								</div>
							</div>
							<div className="col-md-6">
								<div className="modern-form-group">
									<label className="modern-form-label">Bankgironummer</label>
									<input
										type="text"
										className="modern-form-control"
										placeholder="Ange ditt bankgironummer"
										onChange={handleInputChange}
										name='bankgirotNumber'
										value={formData.bankgirotNumber}
									/>
								</div>
							</div>
						</div>
					</div>

					{/* Employee Selection Section */}
					<div className="form-section-title">
						<CreditCard size={18} color="var(--bs-primary)" />
						Välj löner att inkludera
					</div>

					{/* Selection Controls */}
					<div className="selection-controls">
						<button className="btn-selection" onClick={selectAll}>
							Välj alla
						</button>
						<button className="btn-selection" onClick={selectNone}>
							Välj ingen
						</button>
						<div className="selection-summary">
							{selectedEmployeeSalaries.length} av {employeeSalaries?.length || 0} valda
						</div>
					</div>

					{/* Employees Table */}
					<div className="modern-table">
						<table className="table table-sm mb-0">
							<thead>
								<tr>
									<th style={{ width: '50px' }}>Välj</th>
									<th>Anställd</th>
									<th>Nettolön</th>
									<th>Clearing</th>
									<th>Kontonummer</th>
								</tr>
							</thead>
							<tbody>
								{employeeSalaries?.map((employeeSalary) => {
									const isSelected = selectedEmployeeSalaries.some(emp => emp.id === employeeSalary.id);
									return (
										<tr key={employeeSalary.id} className={isSelected ? 'selected' : ''}>
											<td>
												<input
													type="checkbox"
													className="modern-checkbox"
													value={employeeSalary.id}
													onChange={handleSelectChange}
													checked={isSelected}
												/>
											</td>
											<td className="employee-name">{employeeSalary.name}</td>
											<td className="amount-cell">{formatCurrency(employeeSalary.netpay)}</td>
											<td>{employeeSalary.clearingnumber}</td>
											<td>{employeeSalary.accountnumber}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>

					{/* Summary */}
					{selectedEmployeeSalaries.length > 0 && (
						<div className="summary-card mt-3">
							<div className="summary-text">
								Total att betala ({selectedEmployeeSalaries.length} anställda):
							</div>
							<div className="summary-amount">
								{formatCurrency(totalAmount)}
							</div>
						</div>
					)}
				</Modal.Body>

				<Modal.Footer>
					<div className="d-flex justify-content-between w-100 align-items-center">
						<small className="text-muted">
							💡 Kontrollera att bankgirouppgifterna är korrekta innan du skapar filen
						</small>
						<div className="d-flex gap-2">
							<button className="modern-btn btn-modern-secondary" onClick={handleClose}>
								Avbryt
							</button>
							<button
								className="modern-btn btn-modern-primary"
								onClick={() => {
									handleSelect(selectedEmployeeSalaries, formData.customerNumber, formData.bankgirotNumber);
									handleClose();
								}}
								disabled={!formData.customerNumber || !formData.bankgirotNumber || selectedEmployeeSalaries.length === 0}
							>
								<Download size={16} />
								Skapa BG-fil
							</button>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default BankgirotFileDownloadModal;



// import React, { useState } from 'react';
// import { Modal, Button, Form, Table } from 'react-bootstrap';
// const BankgirotFileDownloadModal = ({ show, handleClose, handleSelect, employeeSalaries }) => {
// 	const [selectedEmployeeSalaries, setSelectedEmployeeSalaries] = useState([]);

// 	const handleSelectChange = (event) => {
// 		const id = event.target.value;
// 		const selectedEmployeeSalary = employeeSalaries.find(salary => salary.id === id);
// 		console.log(selectedEmployeeSalary);
// 		setSelectedEmployeeSalaries(prevState =>
// 			prevState.includes(selectedEmployeeSalary) ? prevState.filter(salary => salary.id !== id) : [...prevState, selectedEmployeeSalary]
// 		);
// 	};

// 	const [formData, setFormData] = useState({
// 		customerNumber: '',
// 		bankgirotNumber: '',
// 	});

// 	const handleInputChange = (event) => {
// 		const { name, value } = event.target;

// 		console.log(name, value);

// 		setFormData({ ...formData, [name]: value });
// 	};




// 	return (
// 		<>
// 			<Modal show={show} onHide={handleClose} size='lg'>
// 				<Modal.Header closeButton>
// 					<Modal.Title>Välje Löner att inkludera med i betalningen</Modal.Title>
// 				</Modal.Header>
// 				<Modal.Body>
// 					<Form.Group className="mb-5" controlId="customerNumber">
// 						<Form.Label>Ditt kundnummer</Form.Label>
// 						<Form.Control type="text" placeholder="Ange ditt kundnummer hos bankgirot" onChange={handleInputChange} name='customerNumber' />
// 					</Form.Group>

// 					<Form.Group controlId="bankgirotNumber">
// 						<Form.Label>Bankgironummer</Form.Label>
// 						<Form.Control type="text" placeholder="Ange ditt bankgironummer" onChange={handleInputChange} name='bankgirotNumber' />
// 					</Form.Group>
// 					<Table responsive className="header-border mt-5">
// 						<thead>
// 							<tr>
// 								<th></th>
// 								<th>Namn</th>
// 								<th>Att betala</th>
// 								<th>Clearingnummer</th>
// 								<th>Kontonummer</th>
// 								{/* Add more columns as needed */}
// 							</tr>
// 						</thead>
// 						<tbody>
// 							{employeeSalaries.map((employeeSalary, index) => (
// 								<tr key={employeeSalary.id}>
// 									<td>
// 										<Form.Check
// 											key={employeeSalary.id}
// 											type="checkbox"
// 											value={employeeSalary.id}
// 											onChange={handleSelectChange}
// 										/>
// 									</td>
// 									<td>{employeeSalary.name}</td>
// 									<td>{employeeSalary.netpay}</td>
// 									<td>{employeeSalary.clearingnumber}</td>
// 									<td>{employeeSalary.accountnumber}</td>
// 									{/* Add more cells as needed */}
// 								</tr>
// 							))}
// 						</tbody>
// 					</Table>

// 				</Modal.Body>
// 				<Modal.Footer>
// 					<Button variant="secondary" onClick={handleClose}>
// 						Stäng
// 					</Button>
// 					<Button variant="primary" onClick={() => { handleSelect(selectedEmployeeSalaries, formData.customerNumber, formData.bankgirotNumber); handleClose(); }}>
// 						Lägg till
// 					</Button>
// 				</Modal.Footer>
// 			</Modal>
// 		</>
// 	);
// };

// export default BankgirotFileDownloadModal;
